import { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useTranslation } from '@/hooks/useTranslation';

function ErrorFallback() {
  const { t } = useTranslation();
  
  return (
    <div className="flex h-screen">
      <div className="flex flex-col m-auto gap-4 items-center">
        <h2>{t('components.generic.ErrorBoundary.title')}</h2>
        <p>{t('components.generic.ErrorBoundary.notified')}</p>
        <p>{t('components.generic.ErrorBoundary.retry')}</p>
        <button
          className="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('components.generic.ErrorBoundary.reload')}
        </button>
      </div>
    </div>
  );
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      {children}
    </ReactErrorBoundary>
  );
}
